// @flow

import React from 'react';

const Ubivox = ({ translate, subscribedToNewsletter, changeToggle } : { translate: any, subscribedToNewsletter: boolean, changeToggle: Function }) => {
  return (
    <div className={`js-ubivox setbox-trigger subscribe-setting ${subscribedToNewsletter ? 'checked' : ''}`}>
      <label htmlFor="lbl-003">
        <i className="ico">
          <div className="settings-area--ico settings-area--ico-news" />
        </i>
        {translate(`settings.news_sub${subscribedToNewsletter ? '_active' : '_inactive'}`)}
      </label>
      <div className="check-box">
        <input
          id="lbl-003"
          className="js-toggle"
          type="checkbox"
          onChange={(e) => changeToggle(e, 'subscribed_to_newsletter')}
          checked={ subscribedToNewsletter ? 'checked' : '' }
          />
      </div>
    </div>
  );
};

export default Ubivox;



// WEBPACK FOOTER //
// ./src/components/main/settings/ubivox.js